// import "bootstrap/dist/css/bootstrap.css";
import React from "react"

import { ConfigProvider } from "antd"
import enUS from "antd/es/locale/en_US"

import { createRoot } from "react-dom/client"
import { BrowserRouter } from "react-router-dom"

import App from "./App"
import reportWebVitals from "./reportWebVitals"
import * as serviceWorkerRegistration from "./serviceWorkerRegistration"

const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href")
const rootElement = document.getElementById("root")
const root = createRoot(rootElement)

root.render(
  <ConfigProvider
    locale={enUS}
    theme={{
      token: {
        fontFamily: '"Open Sans", sans-serif',
      },
    }}
  >
    <BrowserRouter basename={baseUrl}>
      <App />
    </BrowserRouter>
  </ConfigProvider>
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister()

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
